import { render } from "./DataDownload.vue?vue&type=template&id=5188977e&scoped=true"
import script from "./DataDownload.vue?vue&type=script&lang=js"
export * from "./DataDownload.vue?vue&type=script&lang=js"

import "./DataDownload.vue?vue&type=style&index=0&id=5188977e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5188977e"]])

export default __exports__